import React, { Fragment, useContext, useState, useRef, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import Button from "../../lib/ui/buttons/Button";
import InputField from "../../lib/ui/inputs/Input";
import DropDown from "../../lib/ui/dropdown/Dropdown";
import LogoBranding from "../../lib/ui/logoBranding/LogoBranding";
// import LogoGroup from "../../lib/ui/logoBranding/LogoGroup";
import { LangCtx, PayLoadCtx, RoleCtx } from "../../lib/context";
import { langObj } from "../../locale/index";
import "../../layouts/Layouts.css";
import { login, reconfirmApi } from "../../actions/users";
import { Auth } from "aws-amplify";
import Loader from "../../lib/ui/loader/Loader";
import queryString from "query-string";
// import config from "../../config.json";
import {validatePassword } from "../../lib/validation";
// import PhoneInput, { isValidPhoneNumber, parsePhoneNumber } from "react-phone-number-input";
import "react-phone-number-input/style.css";
// import ClinicListItem from "../admin/users/components/clinic/ClinicListItem";
import PlayCircleFilledWhiteIcon from "@material-ui/icons/PlayCircleFilledWhite";
import { toast } from "react-toastify";
import axios from "axios";
import { Country } from "country-state-city";
import { getTerms } from "../../actions/configuration";
import { getSubdomain } from "../../lib/domain";
// const psl = require("psl");

function getQuerystring(name, url = window.location.href) {
    name = name.replace(/[[]]/g, "\\$&");
    const regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)", "i");
    const results = regex.exec(url);

    if (!results) {
        return null;
    }
    if (!results[2]) {
        return "";
    }

    return decodeURIComponent(results[2].replace(/\+/g, " "));
}

const LoginPage = (props) => {
    const history = useHistory();
    const { l, setLang, setCurrencyCode } = useContext(LangCtx);
    const { getPayLoad } = useContext(PayLoadCtx);
    const { setRole } = useContext(RoleCtx);
    // const { custom } = useContext(CustomCtx);
    const [un, setun] = useState("");
    const [psw, setPsw] = useState("");
    const [errmsg, setErr] = useState("");
    const [isLoading, setLoading] = useState(false);
    const inputun = useRef(null);
    const inputpsw = useRef(null);
    const [showPswForm, setPswForm] = useState(false);
    const [newPwd, setNewPwd] = useState("");
    const [confirmPwd, setConfirmPwd] = useState("");
    // const [displayPhne, setDisplayPhne] = useState(false);
    const langOptions = [
        { value: "en", label: l.english },
        { value: "hi", label: l.hindi },
        { value: "fr", label: l.french },
    ];
    // const _domain = psl.parse(window.location.hostname);
    const _domain = getSubdomain(window.location.hostname);

    const [clinicList, setClinicList] = useState();
    const [unlicensedClinic, setUnlicensedClinic] = useState();
    const [countryCode, setCountryCode] = useState(null);
    // let currDate = new Date();
    const redirect = getQuerystring("redirect");
    const loginbtn = true;
    const [support, setSupport] = useState({})

    // const isPhone = useRef(true);
    // const token = "eyJraWQiOiJHTlRvUkFiZXBFWlMzemxQRUJabExWMXE2YzRtQUtmblpuM0JTTFdDbEQ0PSIsImFsZyI6IlJTMjU2In0.eyJjdXN0b206Y29uc3VsdFJvbGUiOiJjbGluaWNBZG1pbiIsInN1YiI6ImY4N2U5ZmE1LTk4MzUtNGM2ZC1hZDYwLTAxMzc4YjkxYmViYiIsImNvZ25pdG86Z3JvdXBzIjpbIkNsaW5pY0FkbWluIl0sImN1c3RvbTpkb21haW4iOiJhcHAiLCJjdXN0b206Zm5hbWUiOiJTdXBlciBBZG1pbiIsImlzcyI6Imh0dHBzOlwvXC9jb2duaXRvLWlkcC5hcC1zb3V0aGVhc3QtMS5hbWF6b25hd3MuY29tXC9hcC1zb3V0aGVhc3QtMV9UY0NuQnR5Z2kiLCJjb2duaXRvOnVzZXJuYW1lIjoiZjg3ZTlmYTUtOTgzNS00YzZkLWFkNjAtMDEzNzhiOTFiZWJiIiwiY3VzdG9tOmVtYWlsIjoicHJ1ZGh2aUBwZW9wbGVsaW5rdmMuY29tIiwib3JpZ2luX2p0aSI6IjE4M2JjY2JjLTNiZTMtNDVmYi05NDQ5LTlhMGM5YjAwODNmMiIsImNvZ25pdG86cm9sZXMiOlsiYXJuOmF3czppYW06OjE3MzA5NTA0NjQ3Nzpyb2xlXC9hLWluY2xpbmljX2F1dGhyb2xlIl0sImF1ZCI6IjZlbDIwdjdkdTNlc2E1ZW5qM3VpMHZpZm5wIiwiY3VzdG9tOnBob25lIjoiKzkxODAxOTQxOTg3MCIsImV2ZW50X2lkIjoiMWU1OTgxYTYtZDQ1NC00NGRhLTk0MzEtNzIwZTU0Njk5M2Q5IiwidG9rZW5fdXNlIjoiaWQiLCJhdXRoX3RpbWUiOjE2MzQ4OTg4NTIsIm5hbWUiOiJTdXBlciBBZG1pbiAiLCJwaG9uZV9udW1iZXIiOiIrOTE4MDE5NDE5ODcwIiwiZXhwIjoxNjM1ODYwMzIzLCJpYXQiOjE2MzU4NTY3MjQsImp0aSI6IjY4MjFkZmU0LTNkNTItNDlhNC05Y2ZlLTkyYzA3MjMzYjVhMiIsImVtYWlsIjoicHJ1ZGh2aUBwZW9wbGVsaW5rdmMuY29tIn0.azKb1TQ9FMA6vnIBqmGi1MwtPz7eyihGWPGPMHLV-dCybwY7RGf7jyoN8cwCqLXQSA8b8ub2CdzRnCWXS75oso5irK_AEeagfQYzVe8-hsa9Cel0oNZ6neu2bR0j6ILDQ2SyYZYk8tSiP6iVP7nL9_1b2JLig02EfILbtzvfRGvMaQnehCuGHtdtz1sJvhTvY0t__8GkFKnSiKYqrvSg8KMSHjJ5n1an9CggDcJ4TeVpnpFifORPUwBiOsBClL4nfpJ1aKGoD54iA4B9cpiZsh9xo5PhLzEnmimlsBj-v4r-6yUNZ9vRYHnINefW_UGOWBfkaCTjN7LjUsNu2OmGLQ";
    // const domain = 'amazon';
    // const expiresIn = 1635932733000 * 1000 + new Date().getTime();
    // const user = '+918019419870';
    // const identity_id = 'ap-southeast-1:2b4d6951-9287-41c1-8c79-f6768a04a501';


    useEffect(() => {
        const query_data = queryString.parse(props.location.search);
        if (query_data && query_data.lang && query_data.lang !== "") {
            setLang(langObj[query_data.lang]);
            localStorage.setItem("lang", query_data.lang);
        }
    }, []);

    const handleLang = (e) => {
        history.push(`/?lang=${e.target.value}`);
    };

    // const getLicenses = async (phone) => {

    //     setun(phone);

    //     let phoneNumber = phone && parsePhoneNumber(phone);


    //     try {
    //         let clinicsRes = await getLicenseStatus(phoneNumber && phoneNumber.nationalNumber);

    //         if (clinicsRes && clinicsRes.data.length) {

    //             //setClinicList(clinicsRes.data)

    //             let clinics = clinicsRes.data;

    //             clinics &&
    //                 clinics.map((clinic) => {
    //                     clinic.label = clinic.clinicName + `(${clinic.subdomain})`;
    //                     clinic.value = clinic.subdomain;
    //                 });

    //             clinics && setClinicList(clinics);

    //             clinics && setUnlicensedClinic(clinics[0]);


    //             // setClinicList(clinics)
    //         } else {
    //             setClinicList(null);
    //         }
    //     } catch (err) {
    //         setClinicList(null);

    //         console.log("Something went wrong while fetching clinics for license ", err);
    //     }
    // };

    const assignClinic = (subdomain) => {

        for (let clinic of clinicList) {
            if (clinic.subdomain === subdomain) {
                setUnlicensedClinic(clinic);
            }
        }

        // clinicList.forEach(clinic => {

        // });
    };

    async function showPosition(position) {
        const lat = position.coords.latitude;
        const lng = position.coords.longitude;
        axios
            .get(`https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${lat}&lon=${lng}`)
            .then((res) => {
                if (res?.data) {
                    if (res?.data?.address?.country_code !== "") {
                        let data = Country.getCountryByCode((res?.data?.address?.country_code).toUpperCase());
                        localStorage.setItem("currencyCode", data.currency);
                        localStorage.setItem("country", res.data.address.country);
                        setCurrencyCode(data.currency);
                    }
                }
            })
            .catch((err) => {
                console.log("err................:(", "err");
            });
    }

    const getData = async () => {
        try {
            // const res = await axios.get('https://ipapi.co/currency/');
            // console.log("res...............:(", res)

            const currentUrl = new URL(window.location.href); // Ensure it uses the current page's URL
            const queryParams = currentUrl.searchParams;
            
            let headless = queryParams.get("headless") === "true"; // Ensure `headless` is treated as a boolean
            
            console.log("*******************************", headless);            
            
            if (navigator?.geolocation && !headless) {
                navigator.geolocation.getCurrentPosition(showPosition, (err) => console.log("error"));
            } else {
                console.log("Geolocation is not supported by this browser.");
            }

            // if (res.data) {
            //     localStorage.setItem('currencyCode', res.data)
            //     setCurrencyCode(res.data);
            // }
        } catch (e) {
            console.log(e);
        }
    };

    const handleSetPassword = async (e) => {
        e.preventDefault();
        if (!isLoading) {
            if (!newPwd || (newPwd && newPwd.trim() === "")) {
                setErr(l.ent_new_pwd);
            } else if (!validatePassword(newPwd)) {
                setErr(l.ent_valid_pwd);
            } else if (confirmPwd !== newPwd) {
                setErr(l.new_conf_match);
            } else {
                setLoading(true);
                setErr("");
                try {
                    const myUser = await Auth.signIn(un.replaceAll(" ", "").toLowerCase(), psw);
                    if (myUser.challengeName === "NEW_PASSWORD_REQUIRED") {
                        setPswForm(true);
                        Auth.completeNewPassword(
                            myUser, // the Cognito User Object
                            newPwd, // the new password
                            // OPTIONAL, the required attributes
                            {
                                //   email: 'xxxx@example.com',
                                //   phone_number: '1234567890'
                            }
                        )
                            .then((user) => {
                                // at this time the user is logged in if no MFA required
                                const userGroups =
                                    user &&
                                        user.signInUserSession &&
                                        user.signInUserSession.accessToken &&
                                        user.signInUserSession.accessToken.payload
                                        ? user.signInUserSession.accessToken.payload["cognito:groups"]
                                        : [];
                                let role =
                                    userGroups.findIndex((group) => group === "Doctor") >= 0
                                        ? "D"
                                        : userGroups.findIndex((group) => group === "Patient") >= 0
                                            ? "P"
                                            : userGroups.findIndex((group) => group === "Clinic") >= 0
                                                ? "C"
                                                : userGroups.findIndex((group) => group === "ClinicAdmin") >= 0
                                                    ? "CA"
                                                    : userGroups.findIndex((group) => group === "Admin") >= 0
                                                        ? "SA"
                                                        : null;
                                (role === "P" || role === "C" || "CA") && getData();
                                setRole(role);
                                getPayLoad();
                                history.push("/doctor-appointments");
                            })
                            .catch((e) => {
                                console.log(e);
                                setLoading(false);
                            });
                    } else if (myUser?.signInUserSession) {
                        const userGroups =
                            myUser &&
                                myUser.signInUserSession &&
                                myUser.signInUserSession.accessToken &&
                                myUser.signInUserSession.accessToken.payload
                                ? myUser.signInUserSession.accessToken.payload["cognito:groups"]
                                : [];
                        let role =
                            userGroups.findIndex((group) => group === "Doctor") >= 0
                                ? "D"
                                : userGroups.findIndex((group) => group === "Patient") >= 0
                                    ? "P"
                                    : userGroups.findIndex((group) => group === "Clinic") >= 0
                                        ? "C"
                                        : userGroups.findIndex((group) => group === "ClinicAdmin") >= 0
                                            ? "CA"
                                            : userGroups.findIndex((group) => group === "Admin") >= 0
                                                ? "SA"
                                                : null;
                        (role === "P" || role === "C" || "CA") && getData();
                        setRole(role);
                        getPayLoad();
                        history.push("/doctor-appointments");
                    } else {
                        setErr("Please try again");
                    }
                } catch (err) {
                    setLoading(false);
                    console.log("err === ", err);
                    // if (err && err.message) {
                    //     setErr(err.message);
                    // } else {
                    setErr("Please try again");
                    // }
                    if (err && err.code === "UserNotConfirmedException") {
                        Auth.resendSignUp(un)
                            .then((res) => {
                                if (res) {
                                    history.push("/verify-account?username=" + encodeURIComponent(un));
                                }
                            })
                            .catch((err) => {
                                console.log("err ===== ", err);
                            });
                    }
                }
            }
        }
    };

    const handleLogin = async (e) => {
        e.preventDefault();
        if (!isLoading) {
            if (!un || (un && un === "")) {
                // setErr(l.pls_enter_ph_number);
                setErr("Please Enter Username");
                inputun.current.focus();
            }
            // else if (config.isOffline ){
            //     // setErr(l.pls_check_ph_number);
            //     setErr('Please Enter valid Username')
            //     inputun.current.focus();
            // } else if (!config.isOffline){
            //     // setErr(l.pls_check_ph_number);
            //     setErr('Please Enter valid Username')
            //     inputun.current.focus();
            // }
            else if (!psw || (psw && psw === "")) {
                setErr(l.enter_pass);
                inputpsw.current.focus();
            } else if (!validatePassword(psw)) {
                setErr(l.ent_correct_pwd);
                inputpsw.current.focus();
            } else {
                setErr("");
                setLoading(true);

                if (process.env.REACT_APP_isOffline === "true") {
                    let body = {
                        phone: un.replace(" ", ""),
                        password: psw,
                    };
                    login(body)
                        .then((res) => {

                            // localStorage.setItem("sub", res.data.userId);

                            if (res?.data) {
                                localStorage.setItem("token", res.data.userToken);
                                let role;
                                if (res && res.data && res.data.consultRole === "patient") {
                                    role = "P";
                                } else if (res && res.data && res.data.consultRole === "doctor") {
                                    role = "D";
                                } else if (res && res.data && res.data.consultRole === "clinic") {
                                    role = "C";
                                } else if (res && res.data && res.data.consultRole === "clinicAdmin") {
                                    role = "CA";
                                } else if (res && res.data && res.data.consultRole === "superAdmin") {
                                    role = "SA";
                                }

                                (role === "P" || role === "C" || "CA") && getData();
                                setRole(role);
                                getPayLoad();
                                // setLoading(false);
                                history.push("/doctor-appointments");

                                // if (payload?.expiryAt > currExpireAt) {
                                //     history.push("/doctor-appointments");
                                // } else {
                                //     history.push(`/place-your-order/INVCCCP/${payload?.doctorsCount}`);
                                // }
                            } else {
                                setErr("Please try again");
                            }
                        })
                        .catch((err) => {
                            setLoading(false);
                            //console.log("err======", err);
                            // if (err && err.code === 'UserNotConfirmedException') {
                            //     history.push('/verify-account?phone=' + un);
                            // }
                            console.log("err === ", err.response);
                            if (err && err.response && err.response.data && err.response.data.error) {
                                setErr(err.response.data.error);
                            } else {
                                setErr("Please try again");
                            }
                        });
                } else {
                    // const phoneNumber = parsePhoneNumber(un)
                    // const countrycode = phoneNumber.countryCallingCode;
                    // const number = phoneNumber.nationalNumber;
                    try {
                            const myUser = await Auth.signIn(un.replaceAll(" ", "").toLowerCase(), psw);
                            if (myUser.challengeName === "NEW_PASSWORD_REQUIRED") {
                                setPswForm(true);
                                setLoading(false);
                            } else if (myUser?.challengeName === "PASSWORD_VERIFIER") {
                                setPswForm(true);
                                setLoading(false);
                            } else {
                                const userGroups =
                                    myUser &&
                                        myUser.signInUserSession &&
                                        myUser.signInUserSession.accessToken &&
                                        myUser.signInUserSession.accessToken.payload
                                        ? myUser.signInUserSession.accessToken.payload["cognito:groups"]
                                        : [];
                                let role =
                                    userGroups.findIndex((group) => group === "Doctor") >= 0
                                        ? "D"
                                        : userGroups.findIndex((group) => group === "Patient") >= 0
                                            ? "P"
                                            : userGroups.findIndex((group) => group === "Clinic") >= 0
                                                ? "C"
                                                : userGroups.findIndex((group) => group === "ClinicAdmin") >= 0
                                                    ? "CA"
                                                    : userGroups.findIndex((group) => group === "Admin") >= 0
                                                        ? "SA"
                                                        : null;
                                (role === "P" || role === "C" || "CA") && getData();
                                setRole(role);
                                getPayLoad();
                                history.push("/doctor-appointments");
                            }
                    } catch (err) {
                        setLoading(false);
                        console.log("err======", err);
                        console.log("err type in login handler catch ::::::::::", err.code, err.message)
                        if (err && err.code === "UserNotConfirmedException") {
                            history.push("/verify-account?phone=" + un);
                        } else if (err && err.message === "User is disabled.") {
                            setErr("Your account is inactivate mode please contact your admin...");
                        } else if (
                            err &&
                            err.message &&
                            err.message === "Temporary password has expired and must be reset by an administrator."
                        ) {
                            let body = {
                                subdomain: _domain.subdomain,
                                email: un,
                            };
                            setLoading(true);
                            reconfirmApi(body)
                                .then((res) => {
                                    if (res.status) {
                                        history.push("/");
                                    } else {
                                        toast.error(err?.res.error?.error, {
                                            position: toast.POSITION.TOP_RIGHT,
                                        });
                                    }
                                    setLoading(false);
                                })
                                .catch((err) => {
                                    setLoading(false);
                                    toast.error(err?.response.data?.error, {
                                        position: toast.POSITION.TOP_RIGHT,
                                    });
                                });
                        } else {
                            let msg = err?.response?.data?.error?.message
                                ? err.response.data.error.message
                                : err?.response?.data?.error
                                    ? err.response.data.error
                                    : err.message
                                        ? err.message
                                        : "Please try again";
                            setErr(msg);
                            // setErr("Incorrect username or password.");
                        }
                    }
                }
            }
        }

        // Auth.federatedSignIn(
        //     domain,
        //     {
        //         token,
        //         // identity_id, // Optional
        //         expires_at: expiresIn * 1000 + new Date().getTime() // the expiration timestamp
        //     },
        //     user
        // ).then(cred => {
        //     // If success, you will get the AWS credentials
        //     console.log(cred);
        //     return Auth.currentAuthenticatedUser();
        // }).catch(e => {
        //     console.log(e)
        // });
    };

    const redirectToPayment = () => {

        if (redirect && redirect !== "" && redirect.includes("place-your-order")) {
            history.push(`${redirect}?username=${unlicensedClinic?.email}&subdomain=${unlicensedClinic?.subdomain}`);
        } else if (unlicensedClinic?.isFree) {
            history.push(
                `/place-your-order/INVCFREE/${unlicensedClinic?.doctorsCount}?username=${unlicensedClinic?.email}&subdomain=${unlicensedClinic?.subdomain}`
            );
        } else {
            history.push(
                `/place-your-order/INVCCCP/${unlicensedClinic?.doctorsCount}?username=${unlicensedClinic?.email}&subdomain=${unlicensedClinic.subdomain}`
            );
        }
    };

    const handleUsername = (e) => {
        let val = e.target.value;
        // if (isPhone.current) {
        if (/[a-zA-Z]/.test(val)) {
            let uname = val.includes(countryCode) ? val.replace(countryCode, "") : val;
            setun(uname);
        } else {
            let uname = val.includes(countryCode) || val.length < 4 ? val : `${countryCode}${val}`;
            setun(uname);
        }
    };

    const getCountryCode = async () => {
        try {
            const countryCode = await fetch("https://ipapi.co/json");
            const res = await countryCode.json();
            setCountryCode(res?.country_calling_code ? res?.country_calling_code : "+91");
        } catch (err) {
            setCountryCode("+91");
        }
    };

    useEffect(() => {
        getCountryCode();
    }, []);

    const handleOpenGmail = (email) => {
        const os = navigator.userAgent;
        // let finalOs = '';
        let width, height, left, top;

        if (os.search('Windows') !== -1) {
            // finalOs = 'Windows';
            width = window.innerWidth / 2;
            height = window.innerHeight / 2;
            left = (window.innerWidth - width) / 4;
            top = (window.innerHeight - height) / 4;
        }
        else if (os.search('Mac') !== -1) {
            // finalOs = 'MacOS';
            width = window.innerWidth / 2;
            height = window.innerHeight / 2;
            left = (window.innerWidth - width) / 2;
            top = (window.innerHeight - height) / 2;
        }
        else if (os.search('X11') !== -1 && !(os.search('Linux') !== -1)) {
            // finalOs = 'UNIX';
            width = window.innerWidth / 2;
            height = window.innerHeight / 2;
            left = (window.innerWidth - width) / 2;
            top = (window.innerHeight - height) / 2;
        }
        else if (os.search('Linux') !== -1 && os.search('X11') !== -1) {
            // finalOs = 'Linux';
            width = window.innerWidth / 2;
            height = window.innerHeight / 2;
            left = (window.innerWidth - width) / 2;
            top = (window.innerHeight - height) / 2;
        }
        window.open(
            `https://mail.google.com/mail/?view=cm&fs=1&to=${email}`,
            'popup',
            `width=${width},height=${height},left=${left},top=${top}`
        );
    };

    const handleGet = () => {
        setLoading(true);
        let query = `?subdomain=${window.location.hostname !== "localhost" ? _domain.subdomain : process.env.REACT_APP_defaultdomian}`;
        if(window.location.hostname!=="localhost" && !window.location.hostname.includes("app")){
        getTerms(query).then((res) => {
            if (res?.status && res?.data) {
                setSupport({ phone: res?.data?.phone, email: res?.data?.email, terms: res?.data?.terms, brandName: res?.data?.brandName })
                setLoading(false);

            }
            setLoading(false);
        }).catch(e => {
            console.log("e.........:", e);
            setLoading(false);
        }
        );}
        else{
            setSupport('')
            setLoading(false)
        }
    };

    useEffect(() => {
        handleGet();
    }, []);

    return (
        <Fragment>
            <div className="coverContainer">
                <div className="outSideContainer">
                    <div className="colCredential">
                        <div className="topRow">
                            <div className="langBlock alignCenter">
                                {_domain.subdomain === process.env.REACT_APP_subdomain && <div className="helpBtn DeskDisplayorNot">
                                    <a
                                        className="logintollfree flexInline alignCntr"
                                        href="https://help.instavc.com/inclinic"
                                        target="_blank"
                                    >
                                        <PlayCircleFilledWhiteIcon className="callIcon" fontSize="small" />
                                        {l.help_center}
                                    </a>
                                </div>}
                                {/* <div className="helpBtn mobDisplayorNot">
                                    <a
                                        className="logintollfree flexInline alignCntr"
                                        href="https://help.instavc.com/inclinic"
                                        target="_blank"
                                    >
                                        <PlayCircleFilledWhiteIcon className="callIcon" fontSize="small" />
                                        {l.help}
                                    </a>
                                </div> */}
                                <DropDown
                                    placeholder="Languages"
                                    value={localStorage.getItem("lang") ? localStorage.getItem("lang") : l.locale}
                                    items={langOptions}
                                    onChange={handleLang}
                                />
                            </div>
                        </div>

                        <div className="bodyRow">
                            <div className="brandingBlock">
                                <LogoBranding />
                            </div>
                            <div className="crdFormBlock">
                                {errmsg && errmsg !== "" && (
                                    <div className="errorBox">
                                        <small className="errorTxt">{errmsg}</small>
                                    </div>
                                )}
                                {isLoading && <Loader />}
                                <div className="colBlock">
                                    {showPswForm ? (
                                        <form id="newPasswordForm" onSubmit={handleSetPassword}>
                                            <InputField
                                                placeholder={l.new_pwd}
                                                type="password"
                                                maxLength="30"
                                                onChange={(e) => setNewPwd(e.target.value.trim())}
                                                value={newPwd}
                                                showPwd={true}
                                            />
                                            <InputField
                                                placeholder={l.conf_new_pwd}
                                                type="password"
                                                maxLength="30"
                                                onChange={(e) => setConfirmPwd(e.target.value.trim())}
                                                value={confirmPwd}
                                                showPwd={true}
                                            />
                                            <div className="rowBlock childRight pdngTB8">
                                                <Link to="/" className="linkTxt">
                                                    {l.login}
                                                </Link>
                                            </div>
                                            <div className="crdBtnContainer">
                                                <Button
                                                    label={l.reset_pwd}
                                                    type="primary"
                                                    size="md"
                                                    fullWidth="fullWidth"
                                                    buttonType="submit"
                                                    onClick={handleSetPassword}
                                                    showPwd={true}
                                                />
                                            </div>
                                        </form>
                                    ) : (
                                        <form id="loginform" onSubmit={handleLogin}>
                                            {/*<div className="inputBox colBlock nopdng">
                                        <PhoneInput
                                            placeholder={l.clinic_ph_number}
                                            type="text"
                                            onChange={(e) => setUserName(e.target.value)}
                                            value={userName} />
                                        <label>{props.label}</label>
                                        {props.error && <span className="inputErrorMsg">{props.errorMsg}</span>}
                            </div>*/}
                                            {/* <InputField
                                            placeholder={l.clinic_ph_number}
                                            type="text"
                                            onChange={handleun}
                                            value={un}
                                            ref={inputun}
                                        /> */}
                                            <div className="inputBox colBlock nopdng">
                                                <small className="inpLabel">{l.username} :</small>
                                                {process.env.REACT_APP_isOffline === "true" ? (
                                                    <InputField
                                                        placeholder={l.enter_ur_usename}
                                                        type="text"
                                                        // onChange={(e) => setun(e.target.value.trim())}
                                                        onChange={handleUsername}
                                                        value={un.replaceAll(" ", "").toLowerCase()}
                                                        ref={inputun}
                                                        maxLength={55}
                                                    />
                                                ) : (
                                                    // displayPhne ?
                                                    //     <PhoneInput
                                                    //     className="customPkgInput"
                                                    //     // addInternationalOption={false}
                                                    //     countryCallingCodeEditable={false}
                                                    //     defaultCountry="IN"
                                                    //     value={un}
                                                    //     ref={inputun}
                                                    //     withCountryCallingCode
                                                    //     international
                                                    //     maxLength="17"
                                                    //     onChange={
                                                    //         window.location.hostname !== "localhost" &&
                                                    //         _domain && _domain.subDomains &&
                                                    //         _domain.subDomains[0] !== config.defaultdomian
                                                    //             ? setun
                                                    //             : getLicenses
                                                    //     }
                                                    // />
                                                    // :
                                                    <InputField
                                                        placeholder={l.enter_ur_usename}
                                                        type="text"
                                                        onChange={handleUsername}
                                                        value={un.replaceAll(" ", "").toLowerCase()}
                                                        ref={inputun}
                                                        maxLength="55"
                                                    />
                                                )}
                                                <label>{props.label}</label>
                                            </div>
                                            {clinicList && <small className="inpLabel">{"Clinic List"}:</small>}
                                            {clinicList && (
                                                <DropDown
                                                    //placeholder={unlicensedClinic}
                                                    items={clinicList}
                                                    value={unlicensedClinic && unlicensedClinic.value}
                                                    onChange={(e) => {
                                                        assignClinic(e.target.value);
                                                    }}
                                                />
                                            )}
                                            <small className="inpLabel">{l.pass}:</small>

                                            <InputField
                                                placeholder={l.enter_pass}
                                                type="password"
                                                onChange={(e) => setPsw(e.target.value.trim())}
                                                value={psw}
                                                ref={inputpsw}
                                                showPwd={true}
                                                maxLength="30"
                                            />

                                            <div className="rowBlock childRight pdngTB8">
                                                <Link to="/forgot-password" className="linkTxt">
                                                    {l.forgot_pass}
                                                </Link>
                                            </div>
                                            <div className="crdBtnContainer">
                                                <Button
                                                    label={l.login}
                                                    color={un === "" || psw === "" ? "#b3d3dc" : "#24a4c4"}
                                                    size="md"
                                                    disabled={un === "" || psw === "" ? true : false}
                                                    fullWidth="fullWidth"
                                                    buttonType="submit"
                                                    onClick={unlicensedClinic ? redirectToPayment : handleLogin}
                                                    loginbtn={loginbtn}
                                                />
                                            </div>
                                        </form>
                                    )}
                                </div>
                            </div>
                        </div>
                        {/* <LogoGroup /> */}
                        <div className="footerRow">
                            <div className="crdRowBlock alignCenter justifyCenter">
                                {/**** Reverse in HIndi ****/}
                                <p className="pTxt mrgRight8 txtCenter">
                                    {l.locale === "hi"
                                        ? (
                                            <>
                                                {support.brandName && support.brandName !== "" ? (
                                                    <strong>{support.brandName}</strong>
                                                ) : (
                                                    <strong>Inclinic</strong>
                                                )}{" "}
                                                {l.new_to_app}?
                                            </>
                                        )
                                        : (
                                            <>
                                                {l.new_to_app}{" "}
                                                {support.brandName && support.brandName !== "" ? (
                                                    <strong>{support.brandName}</strong>
                                                ) : (
                                                    <strong>Inclinic</strong>
                                                )}?
                                            </>
                                        )
                                    }

                                    &nbsp;
                                    {window.location.hostname !== "localhost" &&
                                        _domain &&
                                        _domain.subdomain &&
                                        _domain.subdomain !== process.env.REACT_APP_defaultdomian ? (
                                        <Link to="/patient-signup" className="linkTxt linkTxtMd">
                                            {l.patient_signup}
                                        </Link>
                                    ) : (
                                        <Link to="/clinic-signup" className="linkTxt linkTxtMd">
                                            {l.clinic_signup}
                                        </Link>
                                    )}
                                </p>
                            </div>
                            {/* <div className="crdRowBlock mrgTop16">
                            {/* <Link to="https://www.ayush.gov.in/docs/CCIM_Telemedicine_Guidelines.pdf" className="linkTxt linkTxtSm" target="_blank">{l.guidelines_telemedicine}</Link> */}
                            {/* <a href="https://www.ayush.gov.in/docs/CCIM_Telemedicine_Guidelines.pdf" className="linkTxt linkTxtSm" target="_blank">{l.guidelines_telemedicine}</a> */}
                            {/* </div> */}
                            <div className="crdRowBlock alignCenter justifyCenter">
                                <small className="smallTxt txtCenter blackInactiveTxt ">
                                    {l.Copyright}- {l.i_agree_to_the}{" "}
                                    {/* <a href={support && support.terms && support.terms !== ""?url:"https://www.inclinic.vc/terms-and-conditions/"} target="_blank" className="linkTxt linkTxtSm"> */}
                                    <a href={support && support.terms && support.terms !== ""? '/terms-conditions' :"https://www.inclinic.vc/terms-and-conditions/"} target="_blank" className="linkTxt linkTxtSm" rel="noopener noreferrer">
                                        {" "}
                                        {l.terms_cond}{" "}
                                    </a>
                                </small>
                            </div>
                            {support === null && <small className="smallTxt txtCenter blackInactiveTxt">
                                {l.contact_for}{" "}
                                <a href="https://help.peoplelinkvc.com/portal/en/newticket" target="_blank" className="linkTxt linkTxtSm" rel="noopener noreferrer">
                                    {l.support}
                                </a>
                            </small>}
                            {support !== null && <div className="flexRow justifyCenter pdngXXXS">
                                {support && support?.brandName && <div className="flexInline alignCntr">
                                    {/* <a className='tollfree flexInline alignCntr'>
                                        <small className="linkTxt linkTxtSm pdngXXXS"> Name :</small>
                                        <small className="linkTxt linkTxtSm pdngXXXS">{support.brandName}</small>
                                    </a> */}
                                </div>}
                                {support && support?.phone && <div className="flexInline alignCntr">
                                    <a className='tollfree flexInline alignCntr' href={`tel:${support.phone}`} rel="noopener noreferrer">
                                        <img src="/images/icons/Support.png" alt="img" />
                                        <small className="linkTxt linkTxtSm pdngXXXS">{support.phone}</small>
                                    </a>
                                </div>}
                                {support && support?.email && <div className="flexInline alignCntr pdngXXXS" onClick={() => handleOpenGmail(support.email)}>
                                    <img src="/images/icons/Mail.png" alt="img" />
                                    <small className="linkTxt linkTxtSm pdngXXXS">{support.email}</small>
                                </div>}
                            </div>}
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export default LoginPage;
